const ShipPoIcon = (props: any) => {
    return <img {...props} alt="ship_po.png" src={require('./ship_po.png')} />;
};

export default ShipPoIcon;
